// src/utils/firmsUtils.js
import JSZip from "jszip";
import convertXmlToGeoJSON from "../features/events/convertXmlToGeoJSON";

// Calculate distance between two coordinates using Haversine formula
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Earth's radius in km
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;
};

// Fetch and parse FIRMS data
export const fetchFIRMSData = async () => {
  try {
    const url = `https://firms.modaps.eosdis.nasa.gov/api/kml_fire_footprints/south_asia/24h/c6.1/FirespotArea_south_asia_c6.1_24h.kmz`;
    const response = await fetch(url);
    const kmzData = await response.blob();

    const zip = await JSZip.loadAsync(kmzData);
    const kmlFile = Object.values(zip.files).find((file) =>
      file.name.endsWith(".kml"),
    );

    if (kmlFile) {
      const kmlData = await kmlFile.async("text");
      const convertedGeoJSON = await convertXmlToGeoJSON(kmlData);

      if (convertedGeoJSON && convertedGeoJSON.features) {
        // Extract fire spot coordinates
        const fireSpots = convertedGeoJSON.features
          .filter((feature) => feature.geometry.type === "Point")
          .map((feature) => ({
            lat: feature.geometry.coordinates[1],
            lng: feature.geometry.coordinates[0],
            name: feature.properties.name,
            description: feature.properties.description,
          }));
        return fireSpots;
      }
    }
    return [];
  } catch (error) {
    console.error("Error fetching FIRMS data:", error);
    return [];
  }
};

// Check if a camera location has any FIRMS fire spots within 30km
export const checkFireVerification = (
  cameraLat,
  cameraLng,
  fireSpots,
  radiusKm = 30,
) => {
  if (!cameraLat || !cameraLng || !fireSpots || fireSpots.length === 0) {
    return false;
  }

  for (const spot of fireSpots) {
    const distance = calculateDistance(
      cameraLat,
      cameraLng,
      spot.lat,
      spot.lng,
    );
    if (distance <= radiusKm) {
      return true;
    }
  }
  return false;
};
